/** saves Cards List
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_cardsgetCards
*/
export const SAVE_CARDS = (state, payload) => {
    state.cardsList = payload
}

/** saves Amounts List
@payload { Array } no docs
*/
export const SAVE_AMOUNTS_LIST = (state, payload) => {
    state.amountsList = payload
}

/** saves Favorites List
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_favoriteslist
*/
export const SAVE_FAVORITES = (state, { pageNumber, data }) => {
    state.favoritesList = pageNumber === 1 ? data.favorites : state.favoritesList.concat(data.favorites)
    state.favoritesHasMore = state.favoritesList.length < data.total
}

/** updates operation favorite status */
export const UPDATE_FAVORITE_STATUS = (state, { favoriteId, isFavorite, isFavoritable }) => {
    state.cardsList.find(obj => obj.id === favoriteId).favorite = isFavorite
    state.cardsList.find(obj => obj.id === favoriteId).favoritable = isFavoritable
}

/* ***********************************************
*                  CLEAR MUTATIONS               *
*********************************************** */
export const CLEAR_FEATURE_STATE = (state, payload) => {
    state.cardsList = []
    state.amountsList = []
}
